import { useRef } from 'react';

/** @format */
import { CKEditor } from '@ckeditor/ckeditor5-react';
import FullEditor from '@jaroya/ckeditor5-build-full';

const TextEditor = ({ name, setFieldValue, value }) => {
  const editorRef = useRef();
  return (
    <CKEditor
      editor={FullEditor}
      ref={editorRef}
      data={value}
      config={{
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'link',
            'bulletedList',
            'numberedList',
            'subscript',
            'superscript',
            'fontSize',
            'fontFamily',
            '|',
            'fontColor',
            'fontBackgroundColor',
            'highlight',
            'alignment',
            'outdent',
            'indent',
            '-',
            'undo',
            'redo',
            '|',
            'imageUpload',
            'imageInsert',
            'toggleImageCaption',
            'imageTextAlternative',
            'linkImage',
            'mediaEmbed',
            'blockQuote',
            'insertTable',
            'horizontalLine',
            'htmlEmbed',
            'pageBreak',
            'removeFormat',
            'selectAll',
            'specialCharacters',
            '-',
            'sourceEditing',
            'strikethrough',
            'restrictedEditingException',
            'textPartLanguage',
            'style',
            'todoList',
            'codeBlock',
            'code',
            'findAndReplace',
            'fullScreen',
          ],
        },
        language: 'fa',

        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableCellProperties',
            'tableProperties',
          ],
        },
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        setFieldValue(name, data, true);
      }}
    />
  );
};

export default TextEditor;
